import type { CategoriesMap } from "./types/source.types";

export const TAB_ORDER = ["keyword", "print", "online", "tv", "radio"] as const;

export const CATEGORIES: CategoriesMap = {
  print: {
    id: "print",
    label: "Print",
    subcategories: [
      {
        id: "broadsheet",
        label: "Broadsheet",
        endpoint: "print/broadsheet",
        responseKey: "broadsheet", // set if backend returns a differently named key
        perPage: 50,
      },
      {
        id: "tabloid",
        label: "Tabloid",
        endpoint: "print/tabloid",
        responseKey: "tabloid",
        perPage: 50,
      },
      {
        id: "magazine",
        label: "Magazines",
        endpoint: "print/magazine",
        responseKey: "magazine",
        perPage: 50,
      },
      {
        id: "provincial",
        label: "Provincial",
        endpoint: "print/provincial",
        responseKey: "provincial",
        perPage: 50,
      },
    ],
  },

  online: {
    id: "online",
    label: "Online",
    subcategories: [
      {
        id: "online-news",
        label: "Online News",
        endpoint: "online-news", // returns { online_news: [...], blogs: [...], metadata: {...} }
        responseKey: "online_news",
        perPage: 100,
      },
      {
        id: "blogs",
        label: "Blogs",
        endpoint: "online/blogs",
        responseKey: "online_blog",
        perPage: 100,
      },
    ],
  },

  tv: {
    id: "tv",
    label: "TV",
    subcategories: [
      {
        id: "tv",
        label: "TV",
        endpoint: "video/tv",
        responseKey: "tv",
        perPage: 50,
      },
      {
        id: "cable-tv",
        label: "Cable TV",
        endpoint: "video/cable-tv",
        responseKey: "cable_tv",
        perPage: 50,
      },
    ],
  },

  radio: {
    id: "radio",
    label: "Radio",
    subcategories: [
      {
        id: "radio",
        label: "Radio",
        endpoint: "audio/radio",
        responseKey: "radio",
        perPage: 100,
      },
      {
        id: "am-radio",
        label: "AM Radio",
        endpoint: "audio/am-radio",
        responseKey: "am_radio",
        perPage: 100,
      },
      {
        id: "fm-radio",
        label: "FM Radio",
        endpoint: "audio/fm-radio",
        responseKey: "fm_radio",
        perPage: 100,
      },
    ],
  },
};
